/**
 * Side-effect module: registers the contact record panel with the shell's record-panel
 * registry (DR-11). Registration is LAZY (registerLazyRecordPanel): the
 * mapping is installed synchronously at boot so deep links resolve, but the
 * panel component (and its dependency graph) stays out of the entry chunk
 * and loads on first open. Idempotent.
 */

import { registerLazyRecordPanel } from '../../shell/record-panel-registry'
import '../engagement/register-panels'

registerLazyRecordPanel('contact', () =>
  import('./contact-side-panel').then((m) => ({ default: m.ContactSidePanel })),
)
